// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + (chunkId === 678 ? "component---src-pages-index-js" : chunkId) + "-" + {"678":"ccb26522dc1da3ab163c","731":"b5697f9c99fabff21012","843":"ec4302638027797cca24"}[chunkId] + ".js";
};